export const company = {
  name: "Company |||| Companies",
  fields: {
    name: "Name",
    cnpj: "CNPJ",
    createdAt: "Created at",
    updatedAt: "Updated at",
  },
};
